import React from 'react';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CustomButton from '../../../components/buttons/CustomButton';
import styles from './MarketingShared.module.css';

// Ilustração leve do caminho do lead: origem -> campanha -> lead.
// `step` destaca a etapa da tela atual.
const FLOW = [
  { key: 'source', label: 'Origem', Icon: HubOutlinedIcon },
  { key: 'campaign', label: 'Campanha', Icon: CampaignOutlinedIcon },
  { key: 'lead', label: 'Lead', Icon: PersonAddAlt1OutlinedIcon },
];

function FlowIllustration({ step }) {
  return (
    <div className={styles.flow} aria-hidden="true">
      {FLOW.map(({ key, label, Icon }, index) => (
        <React.Fragment key={key}>
          {index > 0 && <ChevronRightRoundedIcon className={styles.flowArrow} />}
          <span className={`${styles.flowStep} ${key === step ? styles.flowStepActive : ''}`}>
            <span className={styles.flowIcon}><Icon style={{ fontSize: 20 }} /></span>
            <span className={styles.flowLabel}>{label}</span>
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}

/** Lista vazia: sem nada cadastrado (ilustração + atalho) ou busca sem resultado. */
function MarketingEmptyState({ step, title, text, actionLabel, onAction, searching = false }) {
  if (searching) {
    return (
      <div className={styles.emptySearch}>
        <SearchOffRoundedIcon className={styles.emptySearchIcon} />
        Nada encontrado com essa busca.
      </div>
    );
  }

  return (
    <div className={styles.empty}>
      <FlowIllustration step={step} />
      <h4 className={styles.emptyTitle}>{title}</h4>
      <p className={styles.emptyText}>{text}</p>
      {onAction && (
        <CustomButton
          icon={<AddRoundedIcon />}
          label={actionLabel}
          style="main"
          variant="contained"
          onClick={onAction}
        />
      )}
    </div>
  );
}

export default MarketingEmptyState;
